import React, {FC} from "react"
import styled from "styled-components"

import {injectIntl, InjectIntl} from "@irati/utils/lang"

import {Deal} from "@irati/types"

import padding from "@irati/ui/src/global/padding"
import {minWidthMedia} from "@irati/ui/src/global/media"

import Flex from "@irati/ui/src/Flex"
import PerksGoOnlinePill from "@irati-web/perksgo/src/components/PerksGoOnlinePill"
import LocationPill from "@irati-web/geolocation/src/components/LocationPill/LocationPill"

const StyledFlex = styled(Flex)`
  ${minWidthMedia.tablet`
    padding: ${padding.tiny} 0px ${padding.tiny} ${padding.base};
  `}

  ${minWidthMedia.desktop`
    padding: 15px 0px 0px ${padding.base};
  `}
`

interface Props extends InjectIntl {
  showLocation?: boolean,
  deal: Deal,
  isFavouriteDeal: boolean
}

const PillsOverlay: FC<Props> = ({deal, isFavouriteDeal, formatMessage}) => {

  const {isPerksGoRetailDeal, isInStoreDeal} = deal

  if(isFavouriteDeal || (!isPerksGoRetailDeal && !isInStoreDeal)) {
    return null
  }

  return (
    <StyledFlex
      position="absolute"
      width="190px"
      justifyContent="space-between"
      top="0"
      left="0"
      padding="7px 10px 20px 20px">
      {isInStoreDeal && <LocationPill text={formatMessage({id: "perks.deal.inStore.text"})}  />}
      {isPerksGoRetailDeal && <PerksGoOnlinePill text={formatMessage({id: "perks.deal.online.text"})} />}
    </StyledFlex>
  )

}

export default injectIntl(PillsOverlay)
